/**
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */

import { Logger, ValidationPipe } from '@nestjs/common'
import { NestFactory } from '@nestjs/core'
import { AppModule } from './app/app.module'

async function bootstrap() {
  ///k
  const app = await NestFactory.create(AppModule)
  const globalPrefix = 'api'
  app.useGlobalPipes(new ValidationPipe({ transform: true, skipMissingProperties: false, forbidUnknownValues: true }))
  app.setGlobalPrefix(globalPrefix)
  const port = 9003
  await app.listen(port, () => {
    Logger.log('Listening at http://localhost:' + port + '/' + globalPrefix)
  })
}

bootstrap()
